import React from "react";
import _ from "lodash";

import logo from "assets/images/say-what/saywhat-logo.png";

const AfterVoting = ({ users, photo, captions, playerObj, voting_params }) => {
  const pick_top_text = _.get(voting_params, "pick_top_text", "Your Pick!");
  const pick_bottom_text = _.get(
    voting_params,
    "pick_bottom_text",
    "Let's see if it wins!"
  );

  const votedCaption = captions[playerObj.vote];
  const votedUserName = users.find(
    (user) => user.player_id === votedCaption.player_id
  );
  return (
    <div className="your-pick after-vote">
      <img src={logo} className="sw-logo" alt="logo" />
      <p className="txt">{pick_top_text}</p>
      <img src={photo} className="caption-img" alt="" />
      <p className="que">{`"${votedCaption.caption}"`}</p>
      <p className="by">{`by: ${votedUserName.display_name}`}</p>
      <p className="wait-txt">{pick_bottom_text}</p>
    </div>
  );
};

export default AfterVoting;
